import styled, {css} from "styled-components";
import {COLORS} from "../../../shared/consts";
import {toRem} from "shared/helpers";

const mobile = (styles: any) => css`
  ${({ theme }) => theme?.isWidget && styles};

  @media (max-width: 768px) {
    ${styles}
  }
`;

export const Card = styled.div`
  background-color: ${COLORS.BG.SURFACE2};
  color: ${COLORS.FG.DEFAULT};
  border-radius: ${toRem(16)};
  padding: ${toRem(24)};
  display: flex;
  flex-direction: column;
  gap: ${toRem(16)};
  margin-bottom: ${toRem(8)};

  ${mobile(css`
    padding: ${toRem(16)};
  `)}

  ${({ theme }) =>
    theme?.isWidget &&
    css`
      background-color: transparent;
      padding: 0 !important;
    `}
`;

export const Top = styled.div`
  display: flex;
  gap: ${toRem(16)};
  padding: ${toRem(16)};

  ${mobile(css`
    gap: ${toRem(24)};
    align-items: flex-start;
  `)}
`;

export const TopInsideWrap = styled.div`
  display: flex;
  gap: ${toRem(16)};

  ${mobile(css`
    flex-direction: row-reverse;
  `)}
`;

export const Temperature = styled.div`
  font-size: ${toRem(72)};
  font-weight: bolder;

  ${mobile(css`
    font-size: ${toRem(44)};
    line-height: 1;
  `)}
`;

export const Description = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${toRem(4)};

  ${mobile(css`
    gap: ${toRem(2)};
    max-width: ${toRem(139)};
  `)}
`;

export const MainText = styled.div`
  font-size: ${toRem(14)};
`;

export const SubText = styled.div`
  font-size: ${toRem(14)};
  color: ${COLORS.FG.MUTED};

  ${mobile(css`
    font-size: ${toRem(12)};
  `)}
`;

export const InfoGrid = styled.div<{ $isGrid?: boolean }>`
  display: flex;
  gap: ${toRem(16)};
  flex-wrap: wrap;

  ${mobile(css`
    flex-wrap: nowrap;
    overflow-x: auto;
    gap: ${toRem(12)};
    padding-bottom: ${toRem(8)};
    scroll-snap-type: x mandatory;

    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  `)}

  ${({ theme, $isGrid }) =>
    theme?.isWidget &&
    $isGrid &&
    css`
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: ${toRem(12)};
      flex-wrap: unset;
      overflow-x: unset;
      scroll-snap-type: none;
    `}
`;
export const InfoBox = styled.div<{ $isGrid?: boolean }>`
  flex: 1;
  min-width: ${toRem(148)};
  max-width: ${toRem(236)};
  min-height: ${toRem(72)};
  background-color: ${COLORS.BG.SURFACE3};
  padding: ${toRem(12)};
  border-radius: ${toRem(16)};
  display: flex;
  align-items: center;
  gap: ${toRem(12)};

  ${mobile(css`
    scroll-snap-align: start;
    width: fit-content;
  `)}

  ${({ theme, $isGrid }) =>
    theme?.isWidget &&
    $isGrid &&
    css`
      width: auto !important;
      min-width: unset;
      max-width: unset;
      flex: none;
    `}
`;

export const InfoTitle = styled.div`
  font-size: ${toRem(12)};
  color: ${COLORS.FG.MUTED};

  ${mobile(css`
    font-size: ${toRem(12)};
  `)}
`;

export const InfoValue = styled.div`
  font-size: ${toRem(14)};
  font-weight: 500;

  ${mobile(css`
    font-size: ${toRem(14)};
  `)}
`;

export const InsideWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${toRem(2)};
`;

export const ImgWrap = styled.div`
  position: relative;
  display: inline-block;
`;

export const ImgCenterOverlay = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ImgText = styled.span`
  font-size: ${toRem(16)};
  color: ${COLORS.FG.DEFAULT};
`;

export const MainTitle = styled.h1`
  display: none;
  font-size: ${toRem(16)};
  font-weight: bold;

  ${mobile(css`
    display: flex;
    align-items: center;
    gap: ${toRem(8)};
  `)}
`;
